import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { registerLocaleData, Location } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { NgSelectComponent } from '@ng-select/ng-select';
import { EventService } from '../../controller/event.service';
import 'rxjs/add/operator/filter';
import * as Gp from "../../../../../assets/js/GpSDK2D";
import { TealiumUtagService } from '../../../../tealium/utag.service';

@Component({
  selector: 'app-register-lieu',
  templateUrl: './register-lieu.component.html',
  styleUrls: []
})
export class RegisterLieuComponent implements OnInit {


  @ViewChild('regionComp') regionComp: NgSelectComponent;
  @ViewChild('villeComp') villeComp: NgSelectComponent;
  @ViewChild('lieuComp') lieuComp: NgSelectComponent;

  public idRegion: string;
  public idVille: string;
  public idLieu: string;
  public buSlug: string = "";
  public eventSlug: string = "";
  public event: any = false;
  public errorMsg: string = "";
  public errorApi: boolean = false;
  public today: Date = new Date();

  public formPlaces: FormGroup;
  public objectKeys = Object.keys
  public filtres: any;
  public dataRegionSelect: any;
  public dataVille: any = false;
  public dataVilleSelect: any;
  public dataLieu: any = false;
  public dataLieuSelect: any;
  public dataBoutiques: any = false;
  public dataVirtualEvents: any = false;
  public selectRegion: any;
  public selectVille: any;
  public selectLieu: any;
  public addressChosenShop: string = '';
  public dataBoutiquesOther: any = false;
  public markers = []
  region = new FormControl();
  ville = new FormControl();
  lieu = new FormControl();

  @Input() data;
  @Output() dataChange = new EventEmitter();
  @Output() addressEvent = new EventEmitter<string>();

  constructor(private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    public EventController: EventService,
    public tealium: TealiumUtagService
    ) {
  }

  ngOnInit() {
    this.initMap();

    $(document).ready(function () {
      $(document).foundation();
    });


    this.region.setValue(this.EventController.dataForm.region)
    this.ville.setValue(this.EventController.dataForm.ville)
    this.lieu.setValue(this.EventController.dataForm.lieu)
    this.filtres = this.EventController.event.regions;

    // MAJ options select région
    this.dataRegionSelect = new Array();

    let objectKeys = this.objectKeys(this.filtres)
    objectKeys.sort(function (a, b) {
            if(a < b) { return -1; }
            if(a > b) { return 1; }
            return 0;
        });

    objectKeys.forEach((key) => {
      this.dataRegionSelect = [
        ...this.dataRegionSelect,
        {
          "id": key,
          "name": this.filtres[key].name
        }
      ]
    });

    this.formPlaces = this.fb.group({
      region: this.region,
      ville: this.ville,
      lieu: this.lieu
    });

    this.formValid()


    /**
     * On récupère le slug de BU et de EVENT
     */
    this.buSlug = this.route.snapshot.paramMap.get('bu');
    this.eventSlug = this.route.snapshot.paramMap.get('event');

    // On récupère la region, ville et lieu
    this.route.queryParams
      .filter(params => params.region || params.ville || params.lieu)
      .subscribe(params => {
        this.idRegion = params.region;
        this.idVille = params.ville;
        this.idLieu = params.lieu;
      });

    // L'utilisateur arrive sur un lien déjà pré-rempli
    if(this.idRegion !== undefined){
      (<FormControl>this.formPlaces.controls['region']).setValue(this.idRegion);
      this.changeRegion();
    }
    if(this.idVille !== undefined){
      // Update ville
      (<FormControl>this.formPlaces.controls['ville']).setValue(this.idVille);
      this.changeVille();
    }
    if(this.idLieu !== undefined) {
      // Update lieu
      (<FormControl>this.formPlaces.controls['lieu']).setValue(this.idLieu);
      this.changeLieu();
    }
    if(this.idRegion !== undefined && this.idVille !== undefined && this.idLieu !== undefined){
      // Redirige automatiquement à l'étape d'après seulement si l'étape 1 à déjà été validé
      if (this.EventController.dataForm.validStep <= 1) {
        this.nextStep();
      }else{
        var slug = this.EventController.event.slug;
        var underscored_slug = slug.replace('-','_')
        utag.view({
          'type_page':'inscription',
          'domaine':'do',
          'titre_page':'selection_lieu_inscription_'+underscored_slug
        })
      }
    }
    registerLocaleData(localeFr, 'fr');
  }

  /**
   * On vient de modifier la valeur du select 'Région'
   */
  private changeRegion(): void {

    // On vide le select 'Lieu' et 'Ville' et on le passe en disabled
    this.dataLieu = false;
    this.dataLieuSelect = new Array();
    if (this.lieuComp)
      this.lieuComp.itemsList.clearSelected();
    if (this.villeComp)
      this.villeComp.itemsList.clearSelected();

    // On vide la section de résultat
    this.dataBoutiques = false;

    // Si la valeur du select 'Région' est nulle : On vide le select 'Ville'
    if (this.dataRegionSelect == null) {
      this.dataVille = false;
      this.dataVilleSelect = new Array();
      this.villeComp.itemsList.clearSelected();
      this.initMap();
      // Sinon on remplit le select 'Ville' avec la selection du select 'Région'
    } else {
      this.router.navigate([], { queryParams: { region: this.formPlaces.value.region }, queryParamsHandling: 'merge' });
      // Array Ville
      this.dataVille = this.filtres[this.formPlaces.value.region].cities;
      this.markers = [];

      // MAJ options select
      this.dataVilleSelect = new Array();
      this.objectKeys(this.dataVille).forEach((key) => {
        this.dataVilleSelect = [
          ...this.dataVilleSelect,
          {
            "id": key,
            "name": this.dataVille[key].name
          }
        ]
      });

      this.filtres[this.formPlaces.value.region].placeLocation.forEach(el => {
        this.markers = [...this.markers, {
              content : el.name,
              position: {
                  x : el.long,
                  y : el.lat,
                  projection : "CRS:84"
              }
          }]
      })

      this.changePosMap(this.filtres[this.formPlaces.value.region].lat, this.filtres[this.formPlaces.value.region].long, 7, this.markers)
    }

  }

  /**
   * On vient de modifier la valeur du select 'Ville'
   */
  private changeVille(): void {
    // On vide le select 'Lieu' et 'Ville' et on le passe en disabled
    this.dataLieu = false;
    this.dataLieuSelect = new Array();
    if (this.lieuComp)
      this.lieuComp.itemsList.clearSelected();

    // Si la valeur du select 'Ville' est nulle : On vide le select 'Lieu'
    if (this.dataVilleSelect == null || this.dataVilleSelect == false || this.dataVilleSelect == undefined) {
      this.dataLieu = false;
      this.dataLieuSelect = new Array();
      this.lieuComp.itemsList.clearSelected();
    } else {
      // Sinon on remplit le select 'Lieu' avec la selection du select 'Ville'
      this.dataLieu = this.dataVille[this.formPlaces.value.ville].places;

      // MAJ options select
      this.dataLieuSelect = new Array();
      this.objectKeys(this.dataLieu).forEach((key) => {
        this.dataLieuSelect = [
          ...this.dataLieuSelect,
          {
            "id": key,
            "name": this.dataLieu[key].name
          }
        ]
      });
    }

    // On remplit la section de résultat
    this.dataBoutiques = new Array();
    this.objectKeys(this.dataLieu).forEach((key) => {
      this.dataBoutiques.push(this.dataLieu[key]);
    });

    this.changePosMap(this.dataVille[this.formPlaces.value.ville].lat, this.dataVille[this.formPlaces.value.ville].long, 12, this.markers)

    this.router.navigate([], { queryParams: { ville: this.formPlaces.value.ville }, queryParamsHandling: 'merge' });
  }

  private changeLieu(): void {
    // On remplit la section de résultat
    this.dataBoutiques = new Array();

    if (this.dataLieuSelect == null) {
      this.dataLieu = this.dataVille[this.formPlaces.value.lieu].places;
      this.objectKeys(this.dataLieu).forEach((key) => {
        this.dataBoutiques.push(this.dataLieu[key]);
      });
    } else {
      this.dataBoutiques.push(this.dataLieu[this.formPlaces.value.lieu]);
      this.EventController.dataForm = { ...this.EventController.dataForm, dates: this.dataBoutiques[0].dates }
      if (this.dataBoutiques[0].address_complement) {
        this.addressChosenShop = `Adresse : ${this.dataBoutiques[0].address} ${this.dataBoutiques[0].addressComplement} ${this.dataBoutiques[0].postalCode} ${this.dataBoutiques[0].name}`
      } else {
        this.addressChosenShop = `Adresse : ${this.dataBoutiques[0].address} ${this.dataBoutiques[0].postalCode} ${this.dataBoutiques[0].name}`
      }
    }

    this.changePosMap(this.dataLieu[this.formPlaces.value.lieu].lat, this.dataLieu[this.formPlaces.value.lieu].long, 16, this.markers)

    this.router.navigate([], { queryParams: { lieu: this.formPlaces.value.lieu }, queryParamsHandling: 'merge' });
  }

  public formValid(): boolean {
    return this.formPlaces.value.lieu.length == 0 ||
      this.formPlaces.value.region.length == 0 ||
      this.formPlaces.value.ville.length == 0
  }

  public sendLink(track_zone, track_nom, track_cible = "") {    
    var slug = this.EventController.event.slug;
    var buSlug = this.EventController.event.buSlug;
    var underscored_slug = slug.replace('-','_')
    var underscored_buSlug = buSlug.replace('-','_')

    this.tealium.link({
      'track_zone' : underscored_buSlug + '_' + underscored_slug,
      'track_nom': 'choix_lieu',
      'track_cible' :  window.location.origin + '/' + buSlug + '/' + slug + '/' + 'select-slot'
    });
  }

  public nextStep() {
    this.EventController.dataForm = {
      ...this.EventController.dataForm,
      step: this.EventController.dataForm.step + 1,
      validStep: 2,
      ville: this.formPlaces.value.ville,
      region: this.formPlaces.value.region,
      lieu: this.formPlaces.value.lieu
    }
    //emit here
    this.addressEvent.emit(this.addressChosenShop);
    var slug = this.EventController.event.slug;
    var buSlug = this.EventController.event.buSlug;
    var underscored_slug = slug.replace('-','_')
    var underscored_buSlug = buSlug.replace('-','_')
    utag.link({
      'type_page':'inscription',
      'domaine':'do',
      'titre_page': underscored_buSlug + '_-_' + underscored_slug + '_-_select_lieu',
      'track_zone' : underscored_buSlug + '_-_' + underscored_slug + '_-_select_slot',
      'track_nom' : 'choix_lieu',
      'track_cible' :  window.location.origin + '/' + buSlug + '/' + slug + '/' + 'select-slot'
    });
  }

  /**
   *
   * @param lat //Latitude
   * @param long //Longitude
   * @param zoom //Zoom sur la carte
   * @param markers //Tableau de marker
   */
  public changePosMap(lat:number, long:number, zoom:number = 6, markers = []): void {
    document.getElementById('map').innerHTML = ''
    var map = Gp.Map.load(
      "map",
      {
        apiKey: "pratique",
        center : {
          x : long,
          y : lat,
          projection : "CRS:84"
        },
        zoom : zoom,
        layersOptions : {
            "GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2" : {
            }
        },
        markersOptions: markers
      }
    );
  }

  /**
   *
   * @param lat //Latitude
   * @param lng //Longitude
   */
  public initMap(lat = 47.03238225125163, lng = 2.8943134881057717): void {
    document.getElementById('map').innerHTML = ''
    var map = Gp.Map.load(
      "map",
      {
           apiKey: "pratique",
           center : {
              x : lng,
              y : lat,
              projection : "CRS:84"
           },
           zoom : 5,
           layersOptions : {
               "GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2" : {
               }
           },
      }
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/screens/register-event/view/register-lieu/register-lieu.component.ts